export default {
    buttons: {
        yes: 'Ja',
        doubt: 'Twijfel',
        no: 'Nee',
        back: 'Terug',
        next: 'Verder',
        closeTest: 'Test afsluiten',
        redoTest: 'Doe de test opnieuw',
        goToHome: 'Naar beginpagina',
        switchFromHome: 'Website moe na kanker',
        switchFromHomeCancer: 'Algemene test',
        linkTest: 'Doe de test',
        linkStory: 'Lees verhaal',
        linkStories: 'Ervaringen van anderen',
    },
    sliders: {
        'VVV': {
            labelMin: 'Nee, dat klopt niet',
            labelMax: 'Ja, dat klopt',
        },
        'SAL': {
            labelMin: 'Helemaal niet',
            labelMax: 'Zeer ernstig beperkt',
        },
    },
    footer: {
        privacy: 'Privacy',
        disclaimer: 'Disclaimer',
        copyright: 'Copyright 2020',
    },
};
